module.exports = __webpack_public_path__ + "img/gabon.91b3ab4e.svg";